<template>
  <v-app id="app">
    <header v-if="checkHeaderState">
      <app-header-b2b v-if="userB2b" />
      <div v-else>
        <vue-header-jaleko :user="usuario" :logo="logo" :categorias="categorias" v-if="checkHeaderState" @logout="logout()">
          <notificacoes v-if="usuario && usuario.user && usuario.user.email && usuario.user.email !== 'visitante@jaleko.com.br'"></notificacoes>
        </vue-header-jaleko>
      </div>
      <menu-dropdown-cursos :categorias="categorias"></menu-dropdown-cursos>
    </header>
    <v-main>
      <router-view :key="$route.fullPath"></router-view>
    </v-main>
    <v-footer inset width="auto" class="footer" v-if="!isPwa">
      <app-footer-b2b v-if="userB2b"/>
      <app-footer v-else />
    </v-footer>
  </v-app>
</template>

<script>
import Vue from 'vue'
import LoginUtils from '@/core/utils/login-utils'
import VueHeaderJaleko from '@jaleko/header/src/vue-header-jaleko.vue'
import AppFooter from '@/components/footer'
import AppFooterB2b from '@/components/footer/b2b'
import AppHeaderB2b from '@/components/header/b2b'
import { mapState } from 'vuex'
import Constants from '@/core/constants/constants'
import MenuDropdownCursos from '@/components/header/MenuDropdownCursos'
import Notificacoes from '@/components/notifications'
import EmpresaUtils from '@/core/utils/empresa-utils'
import TipoAcesso from '@/core/types/tipo-acesso'

(function (h, o, t, j, a, r) {
  h.hj = h.hj || function () { (h.hj.q = h.hj.q || []).push(arguments) }
  h._hjSettings = { hjid: 1782392, hjsv: 6 }
  a = o.getElementsByTagName('head')[0]
  r = o.createElement('script'); r.async = 1
  r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv
  a.appendChild(r)
})(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=')

export default {
  name: 'App',
  components: {
    AppFooter,
    AppHeaderB2b,
    AppFooterB2b,
    MenuDropdownCursos,
    VueHeaderJaleko,
    Notificacoes
  },
  data () {
    return {
      showHeader: true,
      showFooter: true,
      footer: false
    }
  },
  created () {
    Vue.prototype.$tipoAcesso = TipoAcesso
    Vue.prototype.$empresaUtils = EmpresaUtils
    this.$store.dispatch('getUser')
    this.$store.dispatch('getCategorias')
  },
  computed: {
    ...mapState({
      headerState: state => state.header.headerState,
      footerBackground: state => state.empresa.configEmpresa.footerBackgroundColor,
      document: state => state.empresa.configEmpresa.title,
      usuario: (state) => state.user.infoUser,
      categorias: state => state.conteudo.categorias,
      logo: (state) => state.empresa.configEmpresa.logo
    }),
    checkHeaderState () {
      if (this.showHeader && this.headerState === Constants.LOADED) {
        return true
      } else {
        return false
      }
    },
    isPwa() {
      return LoginUtils.isPwa();
    },
    userB2b () {
      return (this.usuario?.user?.logadoPelaEmpresa && this.usuario?.user?.logadoPelaEmpresa?.b2b === 1)
    }
  },
  methods: {
    logout(){
      LoginUtils.logout()
      window.location = '/logout'
    }
  }
}
</script>
